"use client";

import { useEffect } from "react";

import { useCategoryFilter } from "../../../hooks/useCategoryFilter.hook";
import type { CustomCategoryFacet } from "../../../types/filters.type";
import { CategoryLevel } from "./CategoryLevel";

interface Props {
  facet: CustomCategoryFacet;
  onLabelChange?: (label: string) => void;
  onBackHandlerChange?: (handler: (() => void) | null) => void;
  isCompact?: boolean;
}

export function CustomCategoryFilter({
  facet,
  onLabelChange,
  onBackHandlerChange,
  isCompact,
}: Props) {
  const {
    currentTree,
    localSelection,
    isAllSelected,
    canNavigateUp,
    navigateDown,
    navigateUp,
    toggleItem,
    selectAll,
    selectRadio,
  } = useCategoryFilter(facet.tree);

  useEffect(() => {
    onLabelChange?.(currentTree.label);
  }, [currentTree.label, onLabelChange]);

  // Registra o "voltar um nível" no drawer enquanto houver ancestral na pilha;
  // ao chegar no topo (ou desmontar) limpa, e o Voltar volta a sair do drill.
  useEffect(() => {
    onBackHandlerChange?.(canNavigateUp ? navigateUp : null);
    return () => onBackHandlerChange?.(null);
  }, [canNavigateUp, navigateUp, onBackHandlerChange]);

  return (
    <CategoryLevel
      tree={currentTree}
      localSelection={localSelection}
      isAllSelected={isAllSelected}
      isCompact={isCompact}
      onNavigate={navigateDown}
      onToggleItem={toggleItem}
      onSelectAll={selectAll}
      onSelectRadio={selectRadio}
    />
  );
}
